'use client'

import React from 'react'

import '@/styles/components/_floatingIconEffect.scss'

interface FloatingIcon {
  left: string
  delay: string
  icon: string
}

interface FloatingIconEffectProps {
  icons?: FloatingIcon[]
  className?: string
}

const defaultIcons: FloatingIcon[] = [
  { left: '3%', delay: '0s', icon: '🎉' },
  { left: '8%', delay: '3.2s', icon: '🎁' },
  { left: '13%', delay: '6.4s', icon: '✨' },
  { left: '18%', delay: '9.6s', icon: '🎊' },
  { left: '23%', delay: '4.4s', icon: '🛍️' },
  { left: '28%', delay: '7.6s', icon: '💸' },
  { left: '33%', delay: '10.8s', icon: '🎈' },
  { left: '38%', delay: '5.2s', icon: '⭐' },
  { left: '43%', delay: '8.4s', icon: '💖' },
  { left: '48%', delay: '1.4s', icon: '🍀' },
  { left: '53%', delay: '4.8s', icon: '🎂' },
  { left: '58%', delay: '8.0s', icon: '🎶' },
  { left: '63%', delay: '5.8s', icon: '🌟' },
  { left: '68%', delay: '2.6s', icon: '💚' },
  { left: '73%', delay: '6.0s', icon: '🦄' },
  { left: '78%', delay: '9.2s', icon: '🍰' },
  { left: '83%', delay: '10.0s', icon: '🎀' },
  { left: '88%', delay: '3.0s', icon: '🧸' },
  { left: '93%', delay: '6.2s', icon: '🍭' },
  { left: '97%', delay: '3.6s', icon: '🫶' }
]

const FloatingIconEffect: React.FC<FloatingIconEffectProps> = ({
  icons = defaultIcons,
  className = ''
}) => {
  return (
    <div
      className={`floating-icon-effect pointer-events-none absolute inset-0 z-0 overflow-hidden ${className}`}>
      {icons.map((item, index) => (
        <span
          key={index}
          className='absolute text-[22px] opacity-40'
          style={{
            left: item.left,
            bottom: '0',
            animation: `float-icon 20s infinite ease-in-out`,
            animationDelay: item.delay
          }}>
          {item.icon}
        </span>
      ))}
    </div>
  )
}

export default FloatingIconEffect
